<template>
  <div v-if="!invoiceId" class="text-gray-400">N/A</div>
  <div v-else-if="!invoiceData[invoiceId]">...</div>
  <div v-else-if="invoiceData[invoiceId].error" class="text-red-500 text-xs" :title="invoiceData[invoiceId].message || 'Could not fetch details.'">
    Error
  </div>
  <div v-else class="font-bold" :class="{ 'text-green-600': invoiceData[invoiceId].amountDue === 0, 'text-red-600': invoiceData[invoiceId].amountDue > 0 }">
    {{ formatCurrency(invoiceData[invoiceId].amountDue) }}
  </div>
</template>

<script setup>
import { defineProps } from 'vue';

defineProps({
  invoiceId: {
    type: String,
    default: null
  },
  invoiceData: {
    type: Object,
    required: true
  }
});

const formatCurrency = (value) => {
  if (typeof value !== 'number') {
    return '';
  }
  return new Intl.NumberFormat('en-VU', { style: 'currency', currency: 'VUV' }).format(value);
};
</script> 